var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramCurrency40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9,0 C13.970565,0 18,4.029435 18,9 C18,13.970565 13.970565,18 9,18 C4.0294377,18 0,13.970565 0,9 C0,4.029435 4.0294377,0 9,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,0 C13.970565,0 18,4.029435 18,9 C18,13.970565 13.970565,18 9,18 C4.0294377,18 0,13.970565 0,9 C0,4.029435 4.0294377,0 9,0 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,0 C7.761425,0 10,2.238575 10,5 C10,7.761425 7.761425,10 5,10 C2.238575,10 0,7.761425 0,5 C0,2.238575 2.238575,0 5,0 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,0 C7.761425,0 10,2.238575 10,5 C10,7.761425 7.761425,10 5,10 C2.238575,10 0,7.761425 0,5 C0,2.238575 2.238575,0 5,0 Z",
    id: "path-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Features-and-Benefits",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,18 C13.970565,18 18,13.970565 18,9 C18,4.029435 13.970565,0 9,0 C4.0294377,0 0,4.029435 0,9 C0,13.970565 4.0294377,18 9,18 Z",
    id: "Fill-1",
    fill: "#FFCC00",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Clip-5",
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,18 C13.970565,18 18,13.970565 18,9 C18,4.0294377 13.970565,0 9,0 C4.0294377,0 0,4.0294377 0,9 C0,13.970565 4.0294377,18 9,18 Z",
    id: "Stroke-4",
    stroke: "#4F4C4D",
    strokeWidth: 1.75,
    mask: "url(#mask-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(5.400000, 4.500000)",
    stroke: "#4F4C4D",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.85,7.875 L0.45,7.875 C1.06552233,7.875 1.6227504,7.6314258 2.0260116,7.2379593 C2.4292728,6.8444937 2.6789112,6.300801 2.6789112,5.7002301 C2.6789112,5.0996583 2.4292728,4.5559665 2.0260116,4.1625 C1.6227504,3.7690335 1.373112,3.2253417 1.373112,2.6247699 C1.373112,2.024199 1.6227504,1.4805063 2.0260116,1.08670581 C2.4292728,0.69323967 2.9865006,0.45 3.6020232,0.45 C4.2175458,0.45 4.7747736,0.69323967 5.1780348,1.08670581 C5.581296,1.4805063 5.8309344,2.024199 5.8309344,2.6247699",
    id: "Stroke-8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.125,
    y1: 4.5,
    x2: 4.5,
    y2: 4.5,
    id: "Stroke-9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(10.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(4.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Clip-27",
    fill: "#FFCC00",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,10 C7.761425,10 10,7.761425 10,5 C10,2.2385765 7.761425,0 5,0 C2.2385765,0 0,2.2385765 0,5 C0,7.761425 2.2385765,10 5,10 Z",
    id: "Stroke-26",
    stroke: "#4F4C4D",
    strokeWidth: 1.75,
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(0.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Clip-27",
    fill: "#FFCC00",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,10 C7.761425,10 10,7.761425 10,5 C10,2.2385765 7.761425,0 5,0 C2.2385765,0 0,2.2385765 0,5 C0,7.761425 2.2385765,10 5,10 Z",
    id: "Stroke-26",
    stroke: "#4F4C4D",
    strokeWidth: 1.75,
    fill: "#FFFFFF",
    mask: "url(#mask-8)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramCurrency40);
export default __webpack_public_path__ + "static/media/pictogramCurrency40.0e5ee358486916dc5ad0909ea5864e82.svg";
export { ForwardRef as ReactComponent };